<div [ngClass]="{'inactive-store': isClosed}" class="container content-login">
  <div class="row logoheader">

    <div class="col-12 outline-0 text-center mt-1 mb-1">
      <div class="logo-background text-center" style="margin: 0 auto;width: 38%">
        <img src="./assets/images/OlarmewithMerchantMate.png" class="logo-background" />
      </div>
    </div>
    <div class="scrolling-wrapper pb-0" style="width: 100% !important;">
      <carousel [showIndicators]="false">
        <div *ngFor="let promo of olarmePromoList;let i=index">
          <slide *ngIf="promo">
            <img [defaultImage]="defaultImage" [lazyLoad]="promo" [src]="promo" alt="olarme promo"
              class="carousel-image">
            <div *ngIf="promotional" [ngStyle]="{
                'border-radius': '1px',
                'box-shadow': '0px 6px 11px 0px rgba(0, 0, 0, 0.8)',
                'background': 'purple',
                'position': 'absolute',
                'top': '10%'
             }">
              <span class="text-white p-4 font-weight-bold-500 font-size-16">{{promotional}}</span>
            </div>
            <div *ngIf="promotional2" [ngStyle]="{                
              'border-radius': '1px',
              'box-shadow': '0px 6px 11px 0px rgba(0, 0, 0, 0.8)',
              'background': 'purple',
              'position': 'absolute',
              'top': '30%'
           }">
              <span class="text-white p-4 font-weight-bold-500 font-size-16">{{promotional2}}</span>
            </div>
            <div *ngIf="promotional3" [ngStyle]="{                
              'border-radius': '1px',
              'box-shadow': '0px 6px 11px 0px rgba(0, 0, 0, 0.8)',
              'background': 'purple',
              'position': 'absolute',
              'top': '50%'
           }">
              <span class="text-white p-4 font-weight-bold-500 font-size-16">{{promotional3}}</span>
            </div>
          </slide>
        </div>
      </carousel>

    </div>
  </div>
  <div class="row">
    <form *ngIf="customerForm" [formGroup]="customerForm">
      <div class="col-12 p-0">
        <div class="p-4 text-center">

          <div class="form-group" style="display: none;">

            <select class="form-control">
              <option>English</option>
              <option>Bahasa Malaysia</option>
            </select>
          </div>
          <div class="row form-group">
            <div *ngIf="!socialProfile || socialProfile.KindId !== 1"
              [ngClass]="(socialProfile && socialProfile.KindId === 2) ? 'col-12' : 'col-6'">
              <app-google-login></app-google-login>
            </div>
            <div *ngIf="!socialProfile || socialProfile.KindId !== 2"
              [ngClass]="(socialProfile && socialProfile.KindId == 1) ? 'col-12' : 'col-6'">
              <app-facebook-login></app-facebook-login>
            </div>
          </div>

          <div class="form-group" *ngIf="!socialProfile">

            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text" style="background-color: white !important;">
                  <i class="far fa-user" aria-hidden="true"></i>
                </span>
              </div>
              <input type="text" formControlName="name" class="form-control border-0 form-control-lg"
                [placeholder]="('LOGIN.NAME' | translate)" aria-label="Name" />
              <div class="input-group-append">
                <span class="input-group-text mr-1 cursor" (click)="genderClick('1')"
                  [ngClass]="{'btn-color text-white': male, 'btn-light text-dark': !male }">
                  <small>{{'LOGIN.MALE' | translate }}</small>
                </span>
                <span class="input-group-text cursor" (click)="genderClick('0')"
                  [ngClass]="{'btn-color text-white': !male, 'btn-light text-dark': male }">
                  <small>{{'LOGIN.FEMALE' | translate }}</small>
                </span>
              </div>
            </div>

          </div>
          <div class="form-group" *ngIf="!socialProfile">
            <ngx-intl-tel-input [cssClass]="'form-control form-control-lg border-0'"
              [preferredCountries]="preferredCountries" [enableAutoCountrySelect]="false" [enablePlaceholder]="true"
              [searchCountryFlag]="true" [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
              [selectFirstCountry]="false" [selectedCountryISO]="selectedCountryISO" [maxLength]="15"
              [phoneValidation]="true" [separateDialCode]="separateDialCode" name="mobile" formControlName="mobile">
            </ngx-intl-tel-input>
          </div>
          <button [disabled]="(customerForm.invalid || !customerForm.controls.mobile.value) && !socialProfile"
            class="btn btn-new btn-block mb-2" (click)="checkPhoneNumber()">{{'LOGIN.START' | translate }}</button>
          <p class="text-muted small">
            {{'LOGIN.AGREE_TERMS' | translate }} <b class="text-primary cursor"
              (click)="onClickPrivacy()">{{'LOGIN.CLICK_FOR_DETAILS' | translate }}</b>

          </p>

          <hr>

          <button *ngIf="!socialProfile" (click)="asGuestClick()"
            class="btn btn-outline-new btn-block">{{'LOGIN.AS_GUEST' | translate }}</button>

        </div>
      </div>
    </form>
  </div>





</div>
<app-loading-component></app-loading-component>
<app-toast [message]="toastMessage" [visible]="showToast"></app-toast>

<ng-template #inAppModal>

  <div class="modal-body inquiry-styles">
    <div class="row">
      <div class="col text-center">

      </div>
      <div class="col-1">
        <i class="fas fa-times fa-lg cursor close" (click)="closeAppIn()"></i>
      </div>
    </div>

    <div class="text-center">
      <h4 style="color: #b34700; font-weight: bold;">To serve you better</h4>
      <p>Please <b>select one</b> of the browsers below <br>
        (whichever is available in your phone)</p>


      <div class="browser-icons-wrapper mb-4 mt-3">
        <div class="browser-icons" style="display: flex; justify-content: center; gap: 20px;">
          <img src="./assets/images/pgicons/edge.png" alt="Edge" style="height: 64px; cursor: pointer;"
            (click)="open('edge')" />
          <img src="./assets/images/pgicons/chrome.png" alt="Chrome" style="height: 64px; cursor: pointer;"
            (click)="open('chrome')" />
          <img src="./assets/images/pgicons/firefox.png" alt="Firefox" style="height: 64px; cursor: pointer;"
            (click)="open('firefox')" />
        </div>
      </div>
    </div>

    <div class="row">
      <button (click)="closePopup()" class="btn btn-outline-new btn-block">Continue</button>
    </div>
  </div>
</ng-template>

<app-drawer [(visible)]="showOrderTypePopup" [customClass]="'blue'" [showCloseButton]="false">

  <div class="kiosk-page">

    <!-- <button class="close-btn">X</button> -->

    <div class="kiosk-header">

      <img *ngIf="companyLogo" [src]="companyLogo" class="store-logo" alt="logo">

      <div class="question">
        Would you like to Dine with us<br>
        or Take Away?
      </div>

    </div>

    <div class="kiosk-panel">
      <div class="row option-row">

        <div class="col-6 option-col">
          <button class="option-card" [ngClass]="{'selected': selectedServiceType === 'DINE_IN'}"
            (click)="selectServiceType('DINE_IN')">
            Dine In
          </button>
        </div>

        <div class="col-6 option-col">
          <button class="option-card" [ngClass]="{'selected': selectedServiceType === 'COLLECTION'}"
            (click)="selectServiceType('COLLECTION')">
            Take Away
          </button>
        </div>

      </div>
    </div>

  </div>

</app-drawer>